import React from 'react'
import propTypes from 'prop-types'
import { defaultSizes } from '../../theme/sizes'
import { getSizeProp } from '../../helpers/component'
import Icon from '../icon/'
import IconButton from 'material-ui/IconButton'

require('./action.scss')

const getConfig = ({ style, size }, { muiTheme }) => {
  let iconSize
  let showText = true

  if (typeof size !== 'undefined') {
    iconSize = muiTheme.action.size[size]
    showText = [defaultSizes.SMALL, defaultSizes.X_SMALL].indexOf(size) === -1
  } else {
    iconSize = muiTheme.action.size[defaultSizes.DEFAULT]
  }

  const ret = {
    showText,
    iconSize,
  }
  return {...ret, ...style}
}

const Action = (props, context) => {
  const { entity, entityIndex, onClick, text, icon, style } = props
  const size = getSizeProp(props)

  const config = getConfig({ style, size }, context)
  const textEl = (config.showText) ? <div className='action-text'>{text}</div> : ('')

  return (
    <li className={`action ${config.showText ? 'action-showText' : ''}`}>
      <IconButton tooltip={config.showText ? '' : text} onClick={(e) => onClick(e, entity, entityIndex)}>
        <Icon name={icon} size={config.iconSize} />
        {textEl}
      </IconButton>
    </li>
  )
}

Action.propTypes = {
  text: propTypes.string,
  icon: propTypes.string,
  size: propTypes.string,
  entity: propTypes.object,
  entityIndex: propTypes.number,
  onClick: propTypes.func,
  style: propTypes.object,
}

Action.contextTypes = {
  muiTheme: propTypes.object,
}

export default Action
